import { render, staticRenderFns } from "./Tabicon.vue?vue&type=template&id=74271892&scoped=true"
import script from "./Tabicon.vue?vue&type=script&lang=js"
export * from "./Tabicon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74271892",
  null
  
)

export default component.exports